module.exports = __webpack_public_path__ + "media/src/ShoppingCart/images/line_icon/check_40px_blue-95be62c458629e277ad120622a760eed.svg";